import { useMemo } from 'react'

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faKey } from '@fortawesome/pro-light-svg-icons/faKey'
import capitalize from 'lodash-es/capitalize'

import { Product, ProjectRole } from '@infura/packages.teams'
import { Select } from '@infura/packages.ui/Select'

import type { AllUKSProjects } from 'hooks/useAllProjects'

import { groupProjectsByOwnership } from 'lib/teams/utils'

interface Props {
  product: Product | 'all-products'
  projects: AllUKSProjects
  selectedProjectId: string | 'all-projects'
  roles: Record<string, ProjectRole>
  groupBy: 'product' | 'ownership'
  displayMode?: 'shared' | 'owned' | 'all'
  className?: string
  disabled?: boolean
  includeAllOption?: boolean
  onChange: (value: any) => void
  testId?: string
}

type productOptionsProp = {
  id: string | number
  text: string
  value: string
  icon: IconDefinition
  disabled?: boolean
}

export function SharingProjectDropdown({
  displayMode = 'all',
  groupBy,
  includeAllOption = true,
  onChange,
  product,
  projects,
  roles,
  selectedProjectId,
  testId
}: Readonly<Props>) {
  const projectsGrouped = useMemo(
    () => (groupBy === 'ownership' ? groupProjectsByOwnership({ projects, roles }) : projects),
    [projects, roles]
  )

  const projectOptions = useMemo(() => {
    const options: Array<productOptionsProp> = []
    const sections = Object.entries(projectsGrouped)

    if (includeAllOption) {
      options.push({
        icon: faKey,
        id: 'all-projects',
        text: 'All API Keys',
        value: 'all-projects'
      })
    }

    sections.forEach(([sectionName, curSectionProjects]) => {
      let filteredProjects = curSectionProjects

      if (displayMode !== 'all') {
        filteredProjects = curSectionProjects.filter(curProject => {
          // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
          if (displayMode === 'shared') return roles[curProject.id] !== 'owner'
          // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
          else return roles[curProject.id] === 'owner'
        })
      }

      if (groupBy === 'ownership' && filteredProjects.length > 0) {
        let labelText = capitalize(sectionName)
        if (groupBy === 'ownership') {
          labelText = sectionName === 'owned' ? `API Keys I Own:` : `API Keys Shared With Me:`
        }

        options.push({
          disabled: true,
          icon: faKey,
          id: sectionName,
          text: labelText,
          value: ''
        })
      }

      filteredProjects.forEach(curProject => {
        options.push({
          icon: faKey,
          // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
          id: curProject.id,
          // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
          text: curProject.name,
          value: 'ethereum'
        })
      })
    })
    return options
  }, [product, roles, displayMode, groupBy, selectedProjectId, projectsGrouped])

  const activeProjectDropdown = projectOptions.find(option => {
    return option.id === selectedProjectId
  })

  return (
    <div>
      <Select
        className='whitespace-nowrap'
        onChange={onChange}
        options={projectOptions}
        testId={testId}
        // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
        value={activeProjectDropdown || null}
      />
    </div>
  )
}
